var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPackage = function SvgPackage(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.667,
    d: "M14.667 28.972a2.67 2.67 0 0 0 2.666 0l9.334-5.333A2.67 2.67 0 0 0 28 21.332V10.665a2.67 2.67 0 0 0-1.333-2.306l-9.334-5.334a2.67 2.67 0 0 0-2.666 0L5.333 8.36A2.67 2.67 0 0 0 4 10.665v10.667a2.67 2.67 0 0 0 1.333 2.307zM16 29.333V16"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.667,
    d: "M4.387 9.332 16 15.999l11.613-6.667M10 5.691l12 6.867"
  })));
};
export default SvgPackage;